/**
 * The admin theme of the widget (plan §3.5 "Admin value" column), bound as
 * `:style` on `<gpt-help>`. The widget reads these custom properties with
 * fallbacks and never declares them itself, so the host values win. Every
 * colour is a V2 token, so a future dark mode only redefines the tokens.
 */
export const GPTHELP_THEME_VARS: Readonly<Record<string, string>> = {
  '--gpthelp-font-family': 'Roboto, system-ui, sans-serif',
  '--gpthelp-font-size': '14px',
  '--gpthelp-accent': 'rgb(var(--c-neutral-900))',
  '--gpthelp-user-bubble-bg': 'rgb(var(--c-neutral-900))',
  '--gpthelp-user-bubble-text': 'rgb(var(--c-on-inverse))',
  '--gpthelp-surface': 'rgb(var(--c-surface))',
  '--gpthelp-surface-muted': 'rgb(var(--c-neutral-50))',
  '--gpthelp-border': 'rgb(var(--c-neutral-200))',
  '--gpthelp-border-subtle': 'rgb(var(--c-neutral-100))',
  '--gpthelp-border-strong': 'rgb(var(--c-neutral-300))',
  '--gpthelp-text': 'rgb(var(--c-neutral-900))',
  '--gpthelp-text-secondary': 'rgb(var(--c-neutral-700))',
  '--gpthelp-text-muted': 'rgb(var(--c-neutral-500))',
  '--gpthelp-text-faint': 'rgb(var(--c-neutral-400))',
  '--gpthelp-focus-ring': 'rgb(var(--c-orange-500) / 0.4)',
  '--gpthelp-active-bg': 'rgb(var(--c-orange-50))',
  '--gpthelp-active-text': 'rgb(var(--c-orange-700))',
  '--gpthelp-success-bg': 'rgb(var(--c-emerald-50))',
  '--gpthelp-success-soft': 'rgb(var(--c-emerald-100))',
  '--gpthelp-success-border': 'rgb(var(--c-emerald-200))',
  '--gpthelp-success-text': 'rgb(var(--c-emerald-700))',
  '--gpthelp-success-solid': 'rgb(var(--c-emerald-600))',
  '--gpthelp-success-solid-text': 'rgb(var(--c-on-color))',
  '--gpthelp-warning-bg': 'rgb(var(--c-amber-50))',
  '--gpthelp-warning-soft': 'rgb(var(--c-amber-100))',
  '--gpthelp-warning-border': 'rgb(var(--c-amber-300))',
  '--gpthelp-warning-text': 'rgb(var(--c-amber-700))',
  '--gpthelp-warning-icon': 'rgb(var(--c-amber-500))',
  '--gpthelp-info-bg': 'rgb(var(--c-sky-50))',
  '--gpthelp-info-border': 'rgb(var(--c-sky-200))',
  '--gpthelp-info-text': 'rgb(var(--c-sky-700))',
  '--gpthelp-danger-bg': 'rgb(var(--c-red-50))',
  '--gpthelp-danger-text': 'rgb(var(--c-red-700))',
  '--gpthelp-radius-control': '8px',
  '--gpthelp-radius-card': '12px',
  '--gpthelp-radius-bubble': '14px',
  '--gpthelp-scrim': 'rgb(var(--c-scrim) / 0.4)',
};
